import {Component, OnInit, OnDestroy} from '@angular/core';
import {Constants} from 'src/app/shared/utils/constants';
import {AffiliateService} from '../affiliate.service';
import {AppService} from '../../../app.service';
import {NumNotRoundPipe} from 'src/app/shared/pipes/common.pipe';

@Component({
  selector: 'rox-symbol-list',
  templateUrl: './symbol-list.component.html',
  styleUrls: ['./symbol-list.component.sass']
})

export class SymbolListComponent implements OnInit, OnDestroy {
  subscription: any = {};
  showResetDialog: Boolean = false;
  showEditSymbolDialog: Boolean = false;
  symbolList = []
  symbolSuffixList = [
    "All",
    ...Constants.SYMBOL_SUFFIX
  ];
  filter = {
    search: "",
    symbolSuffix: "All"
  };
  symbolDetail = {
    readonly: true,
    index:0,
    symbol:'',
    volume:"0",
    totalIBReward:"0",
    directIBReward:"0",
    precedingLevelIBReward:"0",
    platformOwnerReward:"0"
  }
  files: any[] = [];
  error:any = false;
  resetSymbolId = -1
  errorImport:any = false
  
  constructor( 
    private service: AffiliateService,
    private appService: AppService,
    private decimal: NumNotRoundPipe
    ) {
    
  }

  ngOnInit(): void {
    this.getListSymbols()
  }

  closeEditSymbolDialog(){
    this.showEditSymbolDialog = false; 
    this.symbolDetail.readonly = true
  }

  getListSymbols(): void{
    const params = {
      q: this.filter.search?this.filter.search.trim():''
    };
    this.subscription.getListSymbols = this.service.getIBListSymbols(params).subscribe(
      res=>{
        if(res.status == 1000){
          this.symbolList = res.data
          this.filterBySymbolSuffix(this.filter.symbolSuffix)
          
        }
      }
    )
  }

  filterBySymbolSuffix(symbolSuffix):void{
    if(symbolSuffix != 'All'){
      if(symbolSuffix != 'main'){
        this.symbolList = this.symbolList.filter(s=>s.symbol.includes(symbolSuffix))
      }else{
        this.symbolList = this.symbolList.filter(s=>s.symbol.split(".").length == 1)
      }
    }
  }

  search():void {
    this.getListSymbols()
  }

  apply():void {
    this.getListSymbols()
  }

  openResetDialog(symbol):void {
    this.showResetDialog = true
    this.resetSymbolId = symbol.id
  }

  cancelResetDialog():void {
    this.showResetDialog = false
  }

  resetSymbol():void {
    this.showResetDialog = false
    if(this.resetSymbolId<0) return
    // this.symbolList.splice(this.resetSymbolId, 1)
    this.subscription.resetSymbol = this.service.resetIBRewardSymbol(this.resetSymbolId).subscribe(
      res=>{
        if(res.status != 1000){
          this.appService.showError('Reset symbol fail');
        }else{
          this.appService.showSuccess('Reset symbol success');
          this.refresh()
        }
        this.resetSymbolId = -1;
      }
    )
  }

  editSymbol(symbol, index):void { 
    this.showEditSymbolDialog = true
    this.error = false
    this.symbolDetail = {
      index:index,
      readonly: true,
      symbol: symbol.symbol,
      volume: symbol.volume,
      totalIBReward: symbol.total_reward ,
      directIBReward: symbol.direct_ib_reward ,
      precedingLevelIBReward: symbol.preceding_ib_reward ,
      platformOwnerReward: this.decimal.transform(symbol.platform_reward, Constants.FIXED_NUMBER.eth)
    }
  }

  editSymbolDialog():void {
    this.symbolDetail.readonly = false
  }

  chooseFileImportCSV():void {
    document.getElementById("symbol-list-import-btn").click()
  }
 
  importCSV(files): void {
    if (files && files.length) {
      const formData = new FormData();
      formData.append('file', files[0],"[PROXY]");
      this.subscription.importCSV = this.service.importIBRewardCSV(formData)
      .subscribe(res=>{
        if(res.status == 1000){
          this.appService.showSuccess('Import file success');
          this.refresh()
        }else{
          this.appService.showError('Import file fail');
          if(Constants.IMPORT_ERROR_MESSAGE[res.result]){
            this.errorImport = `${Constants.IMPORT_ERROR_MESSAGE[res.result]}`
            this.files = []
            return
          }
          this.errorImport = []
          res.result.map(r=>{
            if(r.error_code){
              this.errorImport.push(`<div class="mb-1"> Symbol <span class='text-red'> ${r.symbol} </span> import error. ${Constants.IMPORT_ERROR_MESSAGE[r.error_code]} </div>`)
            }
          })
          this.errorImport = this.errorImport.join(" ")
        }
        this.files = []
      });
    }
  }

  refresh():void {
    this.filter = {
      search:"",
      symbolSuffix:'All'
    }
    this.getListSymbols()
  }

  saveEditSymbolDialog():void {
    this.showEditSymbolDialog = false;
    this.symbolDetail.readonly = true
    this.symbolList[this.symbolDetail.index] = {
      ... this.symbolList[this.symbolDetail.index],
      symbol: this.symbolDetail.symbol,
      total_reward: this.symbolDetail.totalIBReward,
      direct_ib_reward: this.symbolDetail.directIBReward,
      preceding_ib_reward: this.symbolDetail.precedingLevelIBReward,
      platform_reward: this.symbolDetail.platformOwnerReward,
      volume: this.symbolDetail.volume
    }
    let params = 
    {
      total_reward: + this.symbolDetail.totalIBReward,
      direct_ib_reward: + this.symbolDetail.directIBReward,
      preceding_ib_reward: + this.symbolDetail.precedingLevelIBReward,
      volume: + this.symbolDetail.volume,
      symbol_id: this.symbolList[this.symbolDetail.index].id
    }
    this.subscription.updateSymbol = this.service.updateIBRewardSymbol(params).subscribe(
      res=>{
        if(res.status == 1000){
          this.appService.showSuccess('Edit symbol success');
          this.getListSymbols();
        }else{
          this.appService.showError('Edit symbol fail');
          this.refresh()
        }
      }
    )
  }

  changeReward(etv): void {
    let checkKey = [38,40,37,39,20,16,17,9,18]
    if(checkKey.includes(etv.keyCode)) {
      return
    }
    this.error = false
    let {totalIBReward, directIBReward, precedingLevelIBReward,platformOwnerReward, volume } = this.symbolDetail
    this.symbolDetail.platformOwnerReward = (+ totalIBReward - +directIBReward - +precedingLevelIBReward).toFixed(3).toString()
    if(+directIBReward > +totalIBReward){
      this.error = "Direct IB reward must be lower or equal to lot amount"
      return
    }
    if(+directIBReward + +precedingLevelIBReward > +totalIBReward){
      this.error = "Direct IB reward and Preceding level IB reward must be lower or equal to lot amount"
      return
    }
    if(+totalIBReward < 0.01){
      this.error = "Smallest payable total IB reward = 0.01 USD "
      return
    }
    if( +volume <=0 || +this.symbolDetail.platformOwnerReward <0 || +directIBReward <0 || +precedingLevelIBReward <0 || +totalIBReward <0){
      this.error = 'Invalid number. One of the fields must not be less than zero!'
    }
    if(+volume == 0){
      this.error = 'Invalid number. Volume must not be equal to zero!'
    }
  
  }

  ngOnDestroy(): void {
    for (const prop in this.subscription) {
      if (this.subscription[prop]) {
        this.subscription[prop].unsubscribe();
      }
    }
  }
}